// extracted by mini-css-extract-plugin
export default {"score":"highlight_score__gVkuV"};